import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: '',
}

export const guessingnumberSlice = createSlice({
  name: 'guesingnumberSliceName',
  initialState,
  reducers: {
    addNumber: (state) => {
      state.loading = true;
    },
    getNumber: (state) => {
      state.loading = true;
    },
    getOneNumber: (state) => {
      state.loading = true;
    },

    successNumber: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    removeNumber: (state) => {
      state.loading = true;
    },
    updateNumber: (state) => {
      state.loading = true;
    },
    emptyCart: (state, action) => {
      state.value += action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { addNumber, removeNumber, updateNumber, getNumber, successNumber, getOneNumber } = guessingnumberSlice.actions

export default guessingnumberSlice.reducer